import { SalesOrderStatus } from '../constants/sales-order-status.js';
import { leafLinkStatusReflectsAction } from './leaflink-status-reflects-action.js';
const ENDING_ACTION_BY_STATUS_ID = {
    [SalesOrderStatus.CANCELLED]: 'cancel',
    [SalesOrderStatus.REJECTED]: 'reject',
};
/** Whether Nudool already ended the order in a way the LeafLink status reflects, so an order LeafLink ended has nothing left to apply. */
export function salesOrderEndedLikeLeafLink(salesOrderStatusId, leafLinkStatus) {
    const action = salesOrderStatusId == null ? undefined : ENDING_ACTION_BY_STATUS_ID[salesOrderStatusId];
    return action != null && leafLinkStatusReflectsAction(leafLinkStatus, action);
}
//# sourceMappingURL=sales-order-ended-like-leaflink.js.map